<template>
    <v-card flat v-if="hasAnItem">
        <v-btn-toggle v-model="key" v-if="1 < keys.length" class="lang-toggle">
            <template v-for="value in keys">
                <v-btn v-bind="{ value }" :key="value"> {{ getKeyText(value) }}</v-btn>
            </template>
        </v-btn-toggle>
        <v-expand-transition>
            <v-responsive v-show="show" :aspect-ratio="16 / 9">
                <youtube v-bind="{ videoId }" fitParent @ready="onReady" style="width: 100%" />
            </v-responsive>
        </v-expand-transition>
    </v-card>
</template>

<script>
import urlParser from "js-video-url-parser";

export default {
    props: {
        work: { type: Object, default: () => ({}) },
    },
    data: () => ({
        key: "ko",
        show: false,
    }),
    computed: {
        keys() {
            return Object.keys(this.work?.youtube || {}).filter((key) => !!this.work?.youtube?.[key]);
        },
        hasAnItem() {
            return !!this.keys.length;
        },
        videoId() {
            if (this.hasAnItem) return urlParser.parse(this.work?.youtube?.[this.key])?.id || "";
            return null;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        keys() {
            this.init();
        },
    },
    methods: {
        init() {
            this.key = this.keys?.[0] || "ko";
        },
        onReady() {
            this.show = true;
        },
        getKeyText(key) {
            switch (key) {
                case "ko": {
                    return "Korean";
                }
                case "en": {
                    return "English";
                }
            }
        },
    },
};
</script>

<style scoped>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
    border-color: #181818 !important;
}
</style>
